import React from "react";
import PortalAddressPicker from "./PortalAddressPicker";
import PortalLocationSelects from "./PortalLocationSelects";
import PortalFieldInfo from "./PortalFieldInfo";

export const EMPTY_ADDRESS_FORM = {
  addressLine1: "",
  addressLine2: "",
  countryId: "",
  stateId: "",
  cityId: "",
  zipCode: "",
};

export function addressFormFromRow(row) {
  return {
    addressLine1: row?.Address_Line_1 || "",
    addressLine2: row?.Address_Line_2 || "",
    countryId: row?.Country_Id ? String(row.Country_Id) : "",
    stateId: row?.State_Id ? String(row.State_Id) : "",
    cityId: row?.City_Id ? String(row.City_Id) : "",
    zipCode: row?.Zip_Code || "",
  };
}

export function addressPayloadFromForm(form) {
  const line1 = String(form.addressLine1 || "").trim();
  const line2 = String(form.addressLine2 || "").trim();
  const zip = String(form.zipCode || "").trim();
  return {
    Address: [line1, line2, zip].filter(Boolean).join(", ") || null,
    Address_Line_1: line1 || null,
    Address_Line_2: line2 || null,
    Country_Id: form.countryId ? Number(form.countryId) : null,
    State_Id: form.stateId ? Number(form.stateId) : null,
    City_Id: form.cityId ? Number(form.cityId) : null,
    Zip_Code: zip || null,
  };
}

function PortalAddressFields({ form, setForm }) {
  const setField = (name, value) => setForm((f) => ({ ...f, [name]: value }));
  const initialQuery = [form.addressLine1, form.addressLine2, form.zipCode]
    .map((part) => String(part || "").trim())
    .filter(Boolean)
    .join(", ");

  return (
    <div className="cportal-field cportal-field--full">
      <label>
        Address
        <PortalFieldInfo label="About address">
          Search with Google Maps or select from the map, then fine-tune the fields below.
        </PortalFieldInfo>
      </label>
      <PortalAddressPicker
        initialQuery={initialQuery}
        onResolved={(resolved) =>
          setForm((f) => ({
            ...f,
            addressLine1: resolved.Address_Line_1 || f.addressLine1,
            addressLine2: resolved.Address_Line_2 || f.addressLine2,
            zipCode: resolved.Zip_Code || f.zipCode,
            countryId: resolved.countryId || f.countryId,
            stateId: resolved.stateId || "",
            cityId: resolved.cityId || "",
          }))
        }
      />
      <div className="cportal-form-grid cportal-form-grid--3 cportal-address-fields-grid">
        <div className="cportal-field">
          <label>Address line 1</label>
          <input
            value={form.addressLine1}
            onChange={(e) => setField("addressLine1", e.target.value)}
          />
        </div>
        <div className="cportal-field">
          <label>Address line 2</label>
          <input
            value={form.addressLine2}
            onChange={(e) => setField("addressLine2", e.target.value)}
          />
        </div>
        <PortalLocationSelects
          countryId={form.countryId}
          stateId={form.stateId}
          cityId={form.cityId}
          onChange={({ countryId, stateId, cityId }) =>
            setForm((f) => ({ ...f, countryId, stateId, cityId }))
          }
        />
        <div className="cportal-field">
          <label>Zip code</label>
          <input value={form.zipCode} onChange={(e) => setField("zipCode", e.target.value)} />
        </div>
      </div>
    </div>
  );
}

export default PortalAddressFields;
